exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.container_0[data-v-28be9193] {\n  padding: 5px;\n  border: 1px solid #dcdfe6;\n}\n.container_0 .contact_1[data-v-28be9193] {\n  margin: -5px;\n  border : 0;\n  color:#c7c7c7;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-28be9193","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/CustomerScheduleInfo.vue
// module id = 560
// module chunks = 75